import { Box, CircularProgress, Divider, IconButton, Paper, Switch, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import NormalTable from "../../../../Component/NormalTable";
import { color } from "../../../../StyleData/Config";
import { masterAPI } from "../../../Masters/dataConfig";
import { axiosPrivate } from "../../../../axios/axios";
import {
  DeleteOutline,
  EditOutlined,
  GroupAdd,
  Save,
} from "@mui/icons-material";
import Labour from "./Labour";
import AddLabour from "../WOCompletion/addLabour";
import { toast } from "react-toastify";

import ResponsiveDialog from "../../../../Component/ResponsiveDialog";
const WorkAssignment = ({ jobPlanId, workOrderId, enableDisable }) => {
  const [dataList, setDataList] = useState([]);
  const [editLabour, setEditLabour] = useState(false);
  const [addLabour, setAddLabour] = useState(false);
  const [woDetail, setWoDetail] = useState(null);
  const [editData, setEditData] = useState({});
  const [changedRows, setChangedRows] = useState({});
  const [taskList, setTaskList] = useState([]);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    const woLink = masterAPI["workOrder"].completeDetail;
    await axiosPrivate
      .get(`${woLink}/${workOrderId}`)
      .then((res) => {
        console.log(res.data.result);
        setWoDetail(res.data.result);
        setDataList(
          (res.data.result.workOrderTaskLabourList || []).filter(
            (item) => !item.isActualLabour,
          ),
        );
        setTaskList(res.data.result.workOrderTaskList || []);
      })
      .catch((e) => {
        setDataList([]);
        setWoDetail(null);
        console.log(e, "error wo assignment");
      });
  };

  const handleEdit = (value) => {
    setEditLabour(true);
    setEditData(value);
  };

  const handleClose = () => {
    setEditData({});
    setEditLabour(false);
    getData();
  };

  const handleDelete = async (id) => {
    const labourDelete = masterAPI["workOrderTaskLabour"].delete;
    await axiosPrivate
      .delete(`${labourDelete}/${id}`)
      .then((res) => {
        console.log(res, "labour success");
        getData();
      })
      .catch((e) => {
        console.log(e, "error labour delete");
      });
  };

  const handleSwitchChange = (row, checked) => {
    setChangedRows((prev) => ({
      ...prev,
      [row.id]: {
        ...row,
        ...prev[row.id],
        workOrderId: workOrderId,
        isAssignedLabour: checked,
      },
    }));
  };

  const handleBulkUpdate = async () => {
    const payload = Object.values(changedRows);
    if (payload.length === 0) {
      toast.error("No switch changes to save");
      return;
    }
    console.log(payload, "payload");
    setSaving(true);
    const bulkUpdateLink = masterAPI["workOrderTaskLabour"].bulkstatusupdate;
    await axiosPrivate
      .put(`${bulkUpdateLink}`, payload)
      .then((res) => {
        console.log(res);
        setChangedRows({});
        getData();
      })
      .catch((e) => {
        console.log(e, "bulkupdate error");
      })
      .finally(() => {
        setSaving(false);
      });
  };

  const handleAddOpen = () => {
    if (Object.keys(changedRows).length > 0) {
      toast.error("Please save switch changes before adding labour");
      return;
    }
    setAddLabour(true);
  };

  const handleAddClose = () => {
    setAddLabour(false);
    getData();
  };
  const columnSortData = dataList.sort((a, b) => a.taskNo - b.taskNo);
  const columns = [
    {
      Header: "Task No",
      accessor: "taskNo",
    },
    {
      Header: "Labour",
      accessor: "labourName",
    },
    {
      Header: "Business",
      accessor: "businessName",
    },
    {
      Header: "Craft",
      accessor: "craftName",
    },

    {
      Header: "Planned Hours",
      accessor: "plannedHours",
      disableFilters: true,
    },
    {
      Header: "Planned Cost",
      accessor: "cost",
      disableFilters: true,
    },
    // {
    //   Header: "Planned Start",
    //   accessor: "plannedStart",
    // },
    {
      Header: "Assigned",
    disableFilters: true,
      Cell: ({ cell }) => {
        const row = cell.row.original;
        const rowId = cell.row.original.id;
        const value =
          changedRows[rowId]?.isAssignedLabour ??
          cell.row.original.isAssignedLabour ??
          false;
      
    const isBusinessEmpty =
      row.businessName == null ||
      row.businessName.trim() === "";

    const isLabourEmpty =
      !row.labourId ||
      row.labourId === "00000000-0000-0000-0000-000000000000";

  
    const hasCraft =
      row.craftId &&
      row.craftId !== "00000000-0000-0000-0000-000000000000";
  
    const isDisabled =
      isBusinessEmpty &&
      isLabourEmpty &&
      hasCraft;
        return (
          <Switch
            checked={value}
            disabled={isDisabled || enableDisable?.labour?.edit === false}
            onChange={(e) =>
              handleSwitchChange(cell.row.original, e.target.checked)
            }
          />
        );
      },
    },
    {
      Header: "Actions",
      Cell: ({ cell }) => {
        // console.log(cell)
        return (
          <Box sx={{ whiteSpace: "nowrap" }}>
            {/* <IconButton
              disabled={enableDisable?.labour?.edit === false}
              onClick={() => {
                handleEdit(cell.row.original);
              }}
            >
              <EditOutlined
                sx={{
                  fontSize: color.masterEditDelButton,
                  color:
                    enableDisable?.labour?.edit === false
                      ? "default"
                      : color.masterEditDelButtonColor,
                }}
              />
            </IconButton> */}
            <IconButton
              disabled={enableDisable?.labour?.delete === false}
              onClick={() => {
                handleDelete(cell.row.original.id);
              }}
            >
              <DeleteOutline
                sx={{
                  fontSize: color.masterEditDelButton,
                  color:
                    enableDisable?.labour?.edit === false
                      ? "default"
                      : color.masterEditDelButtonColor,
                }}
              />
            </IconButton>
          </Box>
        );
      },
      disableFilters: true,
    },
  ];
  return (
    <Box
      sx={{
        boxShadow: "-1px 1px 7px 2px rgb(0 0 0 / 32%)",
        p: 1.5,
        backgroundColor: "white",
        display: "flex",
        flexDirection: "column",
        gap: "1rem",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography
          sx={{
            color: color.masterDialogTitleColor,
            fontSize: color.masterDialogFontSize,
            fontWeight: 400,
          }}
        >
          Details
        </Typography>
        <Box>
          <IconButton
            onClick={handleBulkUpdate}
            disabled={saving || enableDisable?.labour?.edit === false}
          >
            {saving ? (
              <CircularProgress size={20} sx={{ color: "#2362B4" }} />
            ) : (
              <Save
                sx={{
                  color:
                    enableDisable?.labour?.edit === false
                      ? "default"
                      : "#2362B4",
                }}
              />
            )}
          </IconButton>
          <IconButton
            onClick={handleAddOpen}
            disabled={enableDisable?.labour?.create === false}
          >
            <GroupAdd
              sx={{
                color:
                  enableDisable?.labour?.create === false
                    ? "default"
                    : color.masterEditDelButtonColor,
              }}
            />
          </IconButton>
        </Box>
      </Box>
      <Divider sx={{ border: "1px solid rgb(0 0 0 / 17%)" }} />
      <Box>
        <NormalTable data={columnSortData} columns={columns} filt={true} />
      </Box>
      <ResponsiveDialog
        open={editLabour}
        onClose={handleClose}
        fullWidth
        maxWidth={"md"}
        children={
          <Labour
            handleCloseClick={handleClose}
            type={"wo"}
            woDetail={woDetail}
            editData={editData}
          />
        }
      />
      <ResponsiveDialog
        open={addLabour}
        onClose={handleAddClose}
        fullWidth
        maxWidth={"md"}
        children={
          <AddLabour
            handleCloseClick={handleAddClose}
            taskList={taskList}
            workOrderId={workOrderId}
            woDetail={woDetail}
            type={"assigned"}
          />
        }
      />
    </Box>
  );
};

export default WorkAssignment;
